import React from 'react';
import { useTranslation } from 'react-i18next';
import './RefundPolicy.css';

const RefundPolicy = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className={`refund-policy ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="container">
        <div className="policy-header">
          <h1>{t('refund.title')}</h1>
          <p className="last-updated">{t('refund.lastUpdated')}: {t('refund.date')}</p>
        </div>

        <div className="policy-content">
          <p className="policy-intro">{t('refund.intro')}</p>

          {[1, 2, 3, 4, 5, 6].map((n) => (
            <section key={n} className="policy-section">
              <h2>{n}. {t(`refund.section${n}.title`)}</h2>
              <p>{t(`refund.section${n}.content`)}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
